import { render, staticRenderFns } from "./AdminPayments.vue?vue&type=template&id=f6fc95d4&scoped=true"
import script from "./AdminPayments.vue?vue&type=script&lang=js"
export * from "./AdminPayments.vue?vue&type=script&lang=js"
import style0 from "./AdminPayments.vue?vue&type=style&index=0&id=f6fc95d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc95d4",
  null
  
)

export default component.exports